module.exports = __webpack_public_path__ + "img/2_88.897202c1.png";